<template>
	<div class="page"  style="position: relative;overflow-y: auto;">
		<div class="titleView">
			<el-row>
				<el-col :span="5">
					<div style="font-size: 16px;font-weight: bold;padding:0 10px;">调拨单验收</div>
				</el-col>
				<el-col :span="4" :offset="8">
					<el-button type="warning"  size="small">全部拒收</el-button>
					<el-button type="warning"  size="small">全部验收</el-button>
				</el-col>
				<el-col :span="2" >
					<el-button   size="small"  @click="$router.back()">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="titleView">
			<el-row style="padding: 10px;">
				<el-col :span="4">
					<div style="padding:0 10px;">调拨单号:</div>
				</el-col>
				<el-col :span="4" >
					<div>调拨时间:</div>
				</el-col>
				<el-col :span="4" >
					<div>来源门店:</div>
				</el-col>
				<el-col :span="4" >
					<div>调拨人:</div>
				</el-col>
				<el-col :span="4" >
					<div>状态:</div>
				</el-col>
			</el-row>
			<el-row style="padding: 10px;">
				<el-col :span="4">
					<div >调拨备注:</div>
				</el-col>
				
			</el-row>
		</div>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="no" label="编号" column-key="tab3key1">
				<!-- <template slot-scope="scope">
					{{scope.row.type&&scope.row.type.name}}
				</template> -->
			</el-table-column>
			<el-table-column label="名称" column-key="tab3key2">
				<!-- <template slot-scope="scope">
					{{scope.row.code}}
				</template> -->
			</el-table-column>
			<el-table-column label="规格" column-key="tab3key3">
				<!-- <template slot-scope="scope">
					<span>{{scope.row.name}}</span>
				</template> -->
			</el-table-column>
			<el-table-column label="调拨数量" column-key="tab3key4">
				<!-- <template slot-scope="scope">
					<span>{{scope.row.skuName}}</span>
				</template> -->
			</el-table-column>
		
			<el-table-column label="位置" column-key="tab3key5">
				<!-- <template slot-scope="scope">
					{{scope.row.storage}}
				</template> -->
			</el-table-column>
			
			<el-table-column label="操作" column-key="tab3key7">
				<!-- <template slot-scope="scope">
					<el-button @click="curRow2=scope.row;drawerSeeProduct_state=true" type="text" size="small">查看</el-button>
					<el-button @click="curRow2=scope.row;drawerAddProduct_state=true" type="text" size="small">解绑</el-button>
					<el-button @click="del2(scope.row.id)" type="text" size="small">交接</el-button>
				</template> -->
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				tableData:[]
			}
		},
		mounted() {
			
		},
		methods:{}
		
	}
</script>

<style lang="scss" scoped>
	.page {
		height: 100%;
		// 重复头部
		.titleView {
			// width: 98%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}
		}
</style>
